import { render, staticRenderFns } from "./ProductMatchProduct.vue?vue&type=template&id=bcbb4898&scoped=true&"
import script from "./ProductMatchProduct.vue?vue&type=script&lang=js&"
export * from "./ProductMatchProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbb4898",
  null
  
)

export default component.exports